import { ApiFeedbackSettingsResponse } from '../../../api/core/models';
import { ClientBoardV2 } from '../model';

export function apiFeedBackSettingsToFeedbackSettings(
  feedbackSettings?: ApiFeedbackSettingsResponse
): ClientBoardV2['boardSettings']['feedbackSettings'] | undefined {
  if (!feedbackSettings || Object.keys(feedbackSettings).length === 0) {
    return undefined;
  }
  return {
    ...(feedbackSettings?.email?.length ? { email: feedbackSettings.email } : {}),
    ...(feedbackSettings?.organisation?.length ? { organisation: feedbackSettings.organisation } : {}),
    ...(feedbackSettings?.privacyNotice ? { privacyNotice: feedbackSettings.privacyNotice } : {}),
    ...(feedbackSettings?.privacyPolicyUrl ? { privacyPolicyURL: feedbackSettings?.privacyPolicyUrl } : {}),
  };
}
